
import React from 'react'

function Template1(props){
    return <div>Template1</div>
}

export default Template1